module.exports = __webpack_public_path__ + "static/media/golfer-1-a.70fd16a7.png";